export default __webpack_public_path__ + "static/media/illustration.7724096d.png";